"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VinSelectionWidget = exports.defaultVinPlateType = void 0;
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var Types_1 = require("../Types");
var Inputs_1 = require("../Components/Inputs");
var ValuationWidgetContext_1 = require("../Context/ValuationWidgetContext");
var FormContext_1 = require("../Context/FormContext");
var VinCorrectionSelector_1 = __importDefault(require("./VinCorrectionSelector"));
exports.defaultVinPlateType = Types_1.ToggleSelectionChoice.LicensePlate;
var localization = window.Resources.ValuationWidgetResources;
var VinSelectionWidget = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var widgetContext = (0, hooks_1.useContext)(ValuationWidgetContext_1.ValuationWidgetContext);
    var formContext = (0, hooks_1.useContext)(FormContext_1.FormContext);
    var _k = (0, hooks_1.useState)(false), inputHasFocus = _k[0], setInputHasFocus = _k[1];
    var _l = (0, hooks_1.useState)(false), licensePlateInvalid = _l[0], setLicensePlateInvalid = _l[1];
    var _m = (0, hooks_1.useState)('Default message'), licensePlateInvalidMessage = _m[0], setLicensePlateInvalidMessage = _m[1];
    // Reset the widget when the selection type changes
    // This prevents a validation error from lingering after the change
    (0, hooks_1.useEffect)(function () {
        resetWidget();
    }, [props.vinPlateType]);
    var getCurrentEnteredVin = function () {
        var _a, _b;
        return (_b = (_a = formContext.formValue) === null || _a === void 0 ? void 0 : _a.vin) === null || _b === void 0 ? void 0 : _b.enteredVin;
    };
    var getCurrentEnteredLicensePlate = function () { var _a; return (_a = formContext.formValue) === null || _a === void 0 ? void 0 : _a.plate; };
    var resetWidget = function () {
        setInputHasFocus(false);
        setLicensePlateInvalid(false);
    };
    var handleVinInput = function (value) {
        formContext.resetFormWithNewValue(function (x) {
            var _a;
            x.vin = __assign({}, formContext.formValue.vin);
            x.vin.enteredVin = widgetContext.normalizeAlphaNumericInput(value);
            if (value.length === 17) {
                x.vin.attemptedVins = Array.from(new Set(__spreadArray(__spreadArray([], (_a = formContext.formValue.vin) === null || _a === void 0 ? void 0 : _a.attemptedVins, true), [x.vin.enteredVin], false)));
            }
        });
    };
    var handleStateInput = function (value) {
        formContext.resetFormWithNewValue(function (x) {
            x.plate = __assign({}, getCurrentEnteredLicensePlate());
            x.plate.state = widgetContext.normalizeAlphaNumericInput(value);
        });
    };
    var updateFromCorrectedVin = function (newValue) {
        formContext.resetFormWithNewValue(function (x) {
            x.vin = __assign({}, formContext.formValue.vin);
            x.vin.enteredVin = widgetContext.normalizeAlphaNumericInput(newValue);
            x.vin.vinWasCorrected = true;
        });
        window.scrollTo(0, 0);
    };
    var handlePlateInput = function (value) {
        formContext.resetFormWithNewValue(function (x) {
            x.plate = __assign({}, getCurrentEnteredLicensePlate());
            x.plate.plateNumber = value.toUpperCase();
            var invalidReason = widgetContext.getLicensePlateInvalidReason(x.plate.plateNumber);
            switch (invalidReason) {
                case ValuationWidgetContext_1.LicensePlateInvalidReason.TooLong:
                    setLicensePlateInvalidMessage(localization.Validation_LicensePlateTooLong);
                    setLicensePlateInvalid(true);
                    break;
                case ValuationWidgetContext_1.LicensePlateInvalidReason.StartsWithSpaceOrDash:
                    setLicensePlateInvalidMessage(localization.Validation_LicensePlateInvalidStartCharacter);
                    setLicensePlateInvalid(true);
                    break;
                case ValuationWidgetContext_1.LicensePlateInvalidReason.TooManySpecialChars:
                    setLicensePlateInvalidMessage(localization.Validation_LicensePlateTooManySpecialCharacters);
                    setLicensePlateInvalid(true);
                    break;
                case ValuationWidgetContext_1.LicensePlateInvalidReason.InvalidCharacter:
                    setLicensePlateInvalidMessage(localization.Validation_LicensePlateInvalidCharacter);
                    setLicensePlateInvalid(true);
                    break;
                // Empty License Plate is technically invalid, but we should hide the error message
                case ValuationWidgetContext_1.LicensePlateInvalidReason.Empty:
                default:
                    setLicensePlateInvalid(false);
            }
        });
    };
    var getVinInputIconState = function () {
        var currentVin = getCurrentEnteredVin();
        if ((currentVin === null || currentVin === void 0 ? void 0 : currentVin.length) !== 17)
            return Inputs_1.TextInputValidationState.Info;
        return widgetContext.hasValidVin(currentVin)
            ? Inputs_1.TextInputValidationState.Success
            : Inputs_1.TextInputValidationState.Warning;
    };
    var getReturnToDropdownsLink = function () {
        if (!widgetContext.getShowDropdowns || widgetContext.userHasInteractedWithToggle)
            return null;
        switch (widgetContext.getValuationMethod) {
            case Types_1.PublicValuationMethod.LicensePlate:
                return ((0, preact_1.h)("div", { class: "return-to-home-link-container bottom" },
                    (0, preact_1.h)("span", null, localization.CTA_DontKnowYourPlate),
                    (0, preact_1.h)("a", { class: "return-to-home-link green-link", onClick: function () { return widgetContext.updateValuationMethod(Types_1.PublicValuationMethod.YearMakeModelDropdowns); } },
                        (0, preact_1.h)("span", { class: "mobile-only" }, localization.CTA_PickFromList_Mobile),
                        (0, preact_1.h)("span", { class: "desktop-only" }, localization.CTA_PickFromList_Desktop))));
            case Types_1.PublicValuationMethod.Vin:
                return ((0, preact_1.h)("div", { class: "return-to-home-link-container bottom" },
                    (0, preact_1.h)("span", null, localization.CTA_DontKnowYourVin),
                    (0, preact_1.h)("a", { class: "return-to-home-link green-link", onClick: function () { return widgetContext.updateValuationMethod(Types_1.PublicValuationMethod.YearMakeModelDropdowns); } },
                        (0, preact_1.h)("span", { class: "mobile-only" }, localization.CTA_PickFromList_Mobile),
                        (0, preact_1.h)("span", { class: "desktop-only" }, localization.CTA_PickFromList_Desktop))));
        }
        ;
        return null;
    };
    return formContext && ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("div", { id: "vin-plate-selection", className: props.vinPlateType === Types_1.ToggleSelectionChoice.LicensePlate ? "two-columns" : "" }, props.vinPlateType === Types_1.ToggleSelectionChoice.LicensePlate
            ? (0, preact_1.h)(preact_1.Fragment, null,
                (0, preact_1.h)(Inputs_1.AnimatedInputLabel, { label: localization.Input_PlateNumberLabel, labelFor: 'license-plate', isActive: inputHasFocus || ((_b = (_a = getCurrentEnteredLicensePlate()) === null || _a === void 0 ? void 0 : _a.plateNumber) === null || _b === void 0 ? void 0 : _b.length) > 0 },
                    (0, preact_1.h)(Inputs_1.TextInput, { elementId: 'license-plate', inputValue: (_c = getCurrentEnteredLicensePlate()) === null || _c === void 0 ? void 0 : _c.plateNumber, handleInputChange: function (e) { return handlePlateInput(e); }, maxLength: 9, setHasFocus: function (x) { return setInputHasFocus(x); }, hasError: widgetContext.errors.plate && !((_d = getCurrentEnteredLicensePlate()) === null || _d === void 0 ? void 0 : _d.plateNumber) || licensePlateInvalid })),
                (0, preact_1.h)(Inputs_1.AnimatedInputLabel, { label: localization.Input_PlateStateLabel, labelFor: 'state', isActive: ((_e = formContext.formValue.plate.state) === null || _e === void 0 ? void 0 : _e.length) > 0 },
                    (0, preact_1.h)(Inputs_1.SelectInput, { elementId: 'state', inputValue: (_g = (_f = getCurrentEnteredLicensePlate()) === null || _f === void 0 ? void 0 : _f.state) !== null && _g !== void 0 ? _g : "", handleInputChange: function (x) { return handleStateInput(x); }, selectItems: widgetContext.selectionValues.plateStates, hasError: widgetContext.errors.plate && !((_h = getCurrentEnteredLicensePlate()) === null || _h === void 0 ? void 0 : _h.state) })),
                licensePlateInvalid && (0, preact_1.h)("div", { className: "field-validation-error" },
                    licensePlateInvalidMessage,
                    " "))
            : (0, preact_1.h)(preact_1.Fragment, null,
                (0, preact_1.h)(Inputs_1.AnimatedInputLabel, { label: localization.Input_VinLabel, labelFor: 'vin', isActive: inputHasFocus || ((_j = getCurrentEnteredVin()) === null || _j === void 0 ? void 0 : _j.length) > 0 },
                    (0, preact_1.h)(Inputs_1.TextInputWithValidation, { elementId: 'vin', inputValue: getCurrentEnteredVin(), handleInputChange: function (e) { return handleVinInput(e); }, maxLength: 17, validationState: getVinInputIconState(), setHasFocus: function (x) { return setInputHasFocus(x); }, infoIconTitle: localization.Info_VinQuestionMarkIconTitle, hasError: widgetContext.errors.vin })),
                (0, preact_1.h)(VinCorrectionSelector_1.default, { currentVin: getCurrentEnteredVin(), onCorrectedVinClick: function (correctedVin) { return updateFromCorrectedVin(correctedVin); }, onYearMakeModelLinkClick: function () { return widgetContext.updateValuationMethod(Types_1.PublicValuationMethod.YearMakeModelDropdowns); } }))),
        getReturnToDropdownsLink()));
};
exports.VinSelectionWidget = VinSelectionWidget;
